import React from 'react'
import Hero from '../features/Hero'
import Info from '../features/Info'
import Banner from '../components/Banner'
import Navbar from '../features/Navbar'
import Footer from '../components/Footer'
import LargeCard from '../features/LargeCard'
import AppAd from '../components/AppAd'
import FastAd from '../components/FastAd'



const Home = () => {
  return (
    <div className=' '>
      <div className='sticky top-0 z-50'>
        <Navbar />
      </div>
      <section className=''>
        <Hero />
      </section>
      <section className='mt-[50px]'>
        <FastAd/>
      </section>

      <section className='mt-[50px]'>
        <Info />
      </section>
      <section className='mt-[50px]'>
        <Banner />
      </section>
      <section className='mt-[50px]'>
        <LargeCard />
      </section>
      <section className='mt-[50px]'>
        <AppAd/>
      </section>
      <section className=''>
        <Footer/>
      </section> 
    </div>
  )
}

export default Home